import _ from 'lodash';
import pitcherTooltip from '../tooltip/pitcherTooltip';
import { useTranslation } from 'react-i18next';

export default function PitcherTableColumnSet(type) {
    let columnSet = [];
    let tooltipData = pitcherTooltip();
    const { t } = useTranslation();

    if(type === 'total') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('age'), property: 'age'});
        columnSet.push({column: t('game'), property: 'basicStat_gameCnt'});
        columnSet.push({column: t('starter'), property: 'starter'});
        columnSet.push({column: t('win'), property: 'win'});
        columnSet.push({column: t('lose'), property: 'lose'});
        columnSet.push({column: t('save'), property: 'save'});
        columnSet.push({column: t('hold'), property: 'hold'});
        columnSet.push({column: t('ip'), property: 'ip'});
        columnSet.push({column: t('basicStat_tpa'), property: 'basicStat_tpa'});
        columnSet.push({column: t('basicStat_k'), property: 'basicStat_so'});
        columnSet.push({column: t('basicStat_bb'), property: 'basicStat_bb', cellRender: totalBbRender});
        // columnSet.push({column: '사구', property: 'basicStat_hbp'});
        // columnSet.push({column: '고의4구', property: 'basicStat_ibb'});
        columnSet.push({column: t('basicStat_phr'), property: 'basicStat_hr'});
        columnSet.push({column: t('era'), property: 'era'});
        columnSet.push({column: t('fip'), property: 'fip', tooltip: tooltipData['fip']});
        columnSet.push({column: t('whip'), property: 'whip', tooltip: tooltipData['whip']}); 
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']}); 
        columnSet.push({column: t('k9'), property: 'k9', tooltip: tooltipData['k9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('bb9'), property: 'bb9', tooltip: tooltipData['bb9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('hr9'), property: 'hr9', tooltip: tooltipData['hr9'], cellRender: toFixedCellRender}); 
    } else if(type === 'futuresTotal') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('age'), property: 'age'});
        columnSet.push({column: t('game'), property: 'gameCnt'});
        // columnSet.push({column: t('starter'), property: 'starter'});
        columnSet.push({column: t('win'), property: 'win'});
        columnSet.push({column: t('lose'), property: 'lose'});
        columnSet.push({column: t('save'), property: 'save'});
        columnSet.push({column: t('hold'), property: 'hold'});
        columnSet.push({column: t('ip'), property: 'ip'});
        columnSet.push({column: t('basicStat_tpa'), property: 'tpa'});
        columnSet.push({column: t('basicStat_k'), property: 'so'});
        columnSet.push({column: t('basicStat_bb'), property: 'bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_phr'), property: 'hr'});
        columnSet.push({column: t('era'), property: 'era'});
        // columnSet.push({column: t('fip'), property: 'fip', tooltip: tooltipData['fip']});
        columnSet.push({column: t('whip'), property: 'whip', tooltip: tooltipData['whip']}); 
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']}); 
        columnSet.push({column: t('k9'), property: 'k9', tooltip: tooltipData['k9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('bb9'), property: 'bb9', tooltip: tooltipData['bb9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('hr9'), property: 'hr9', tooltip: tooltipData['hr9'], cellRender: toFixedCellRender}); 
    } else if(type === 'pitchData') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('ballCodeName'), property: 'ballCodeName'});
        columnSet.push({column: t('pitchRate'), property: 'pitchRate', cellRender: commonCellRender});
        columnSet.push({column: t('ballSpeed'), property: 'ballSpeed', cellRender: commonCellRender});
        columnSet.push({column: t('#'), property: 'pitchCount'});
        columnSet.push({column: t('pa'), property: 'pa'});
        columnSet.push({column: t('hit'), property: 'hit'});
        columnSet.push({column: t("hr"), property: 'hr'});
        columnSet.push({column: t('xbh'), property: 'xh', cellRender: commonCellRender});
        columnSet.push({column: t('basicStat_k'), property: 'so'});
        columnSet.push({column: t('inplayBall'), property: 'inplay', tooltip: tooltipData['inplay']});
        columnSet.push({column: t('ba'), property: 'avg', cellRender: leadingZeroCellRender});
        columnSet.push({column: t('xBa'), property: 'xba', tooltip: tooltipData['xba'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('xSlg'), property: 'xslg', tooltip: tooltipData['xslg'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('whiffRate'), property: 'swingRate', tooltip: tooltipData['whiff'], cellRender: percentCellRender}); 
        columnSet.push({column: t('chaseRate'), property: 'chaseRate', tooltip: tooltipData['chaseRate'], cellRender: percentCellRender}); 
        columnSet.push({column: t('spinRate'), property: 'spinRate', cellRender: parseIntCellRender}); 
    } else if(type === 'futuresPitchData') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('ballCodeName'), property: 'ballCodeName'});
        columnSet.push({column: t('pitchRate'), property: 'pitchRate'});
        columnSet.push({column: t('ballSpeed'), property: 'avgRelSpeed'});
        columnSet.push({column: t('#'), property: 'totalPitch'});
        columnSet.push({column: t('pa'), property: 'pa'});
        columnSet.push({column: t('hit'), property: 'hit'});
        columnSet.push({column: t("hr"), property: 'hr'});
        columnSet.push({column: t('xbh'), property: 'xh', cellRender: commonCellRender});
        columnSet.push({column: t('basicStat_k'), property: 'so'});
        columnSet.push({column: t('inplayBall'), property: 'inplay', tooltip: tooltipData['inplay']});
        columnSet.push({column: t('ba'), property: 'avg', cellRender: leadingZeroCellRender});
        columnSet.push({column: t('xBa'), property: 'xba', tooltip: tooltipData['xba'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('xSlg'), property: 'xslg', tooltip: tooltipData['xslg'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('whiffRate'), property: 'swingRate', tooltip: tooltipData['whiff']}); 
        columnSet.push({column: t('chaseRate'), property: 'chaseRate', tooltip: tooltipData['chaseRate']}); 
        columnSet.push({column: t('spinRate'), property: 'avgSpinRate', cellRender: parseIntCellRender}); 
    } else if(type === 'pitchingQuality') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('callStrikeRate'), property: 'callStrikeRate', tooltip: tooltipData['strikeRate']});
        columnSet.push({column: t('firstPitchStrikeRate'), property: 'firstPitchStrikeRate', tooltip: tooltipData['firstStrikeRate']});
        columnSet.push({column: t('oSwingRate'), property: 'oSwingRate', tooltip: tooltipData['chaseRate']});
        columnSet.push({column: t('whiffRate'), property: 'whiffRate', tooltip: tooltipData['whiff']});
        columnSet.push({column: t('twoStrikePitchStrikeRate'), property: 'twoStrikePitchStrikeRate', tooltip: tooltipData['twoStrikePitchStrikeRate']});
        columnSet.push({column: t('twoStrikePitchChaseRate'), property: 'twoStrikePitchChaseRate', tooltip: tooltipData['twoStrikePitchChaseRate']});
        columnSet.push({column: t('twoStrikePitchWhiffRate'), property: 'twoStrikePitchWhiffRate', tooltip: tooltipData['twoStrikePitchWhiffRate']});
        columnSet.push({column: t('zoneRate'), property: 'zoneRate', tooltip: tooltipData['zoneRate']});
        columnSet.push({column: t('tpaDivPitch'), property: 'tpaDivPitch', tooltip: tooltipData['tpaDivPitch']});
        columnSet.push({column: t('k9'), property: 'k9', tooltip: tooltipData['k9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('bb9'), property: 'bb9', tooltip: tooltipData['bb9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('hit9'), property: 'hit9', tooltip: tooltipData['hit9'], cellRender: toFixedCellRender});
        columnSet.push({column: t('hr9'), property: 'hr9', tooltip: tooltipData['hr9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('kRate'), property: 'kRate', tooltip: tooltipData['kRate']}); 
        columnSet.push({column: t('bbRate'), property: 'bbRate', tooltip: tooltipData['bbRate']});
    } else if(type === 'futuresPitchingQuality') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('callStrikeRate'), property: 'strikeRate', tooltip: tooltipData['strikeRate']});
        columnSet.push({column: t('firstPitchStrikeRate'), property: 'firstPitchStrikeRate', tooltip: tooltipData['firstStrikeRate']});
        columnSet.push({column: t('oSwingRate'), property: 'chaseRate', tooltip: tooltipData['chaseRate']});
        columnSet.push({column: t('whiffRate'), property: 'whiffRate', tooltip: tooltipData['whiff']});
        columnSet.push({column: t('twoStrikePitchStrikeRate'), property: 'twiStrikePitchStrikeRate', tooltip: tooltipData['twoStrikePitchStrikeRate']});
        columnSet.push({column: t('twoStrikePitchChaseRate'), property: 'twoStrikePitchChaseRate', tooltip: tooltipData['twoStrikePitchChaseRate']});
        columnSet.push({column: t('twoStrikePitchWhiffRate'), property: 'twoStrikePitchSwingRate', tooltip: tooltipData['twoStrikePitchWhiffRate']});
        columnSet.push({column: t('zoneRate'), property: 'zoneRate', tooltip: tooltipData['zoneRate']});
        columnSet.push({column: t('tpaDivPitch'), property: 'pitchPerPa', tooltip: tooltipData['tpaDivPitch']});
        columnSet.push({column: t('k9'), property: 'k9', tooltip: tooltipData['k9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('bb9'), property: 'bb9', tooltip: tooltipData['bb9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('hit9'), property: 'hit9', tooltip: tooltipData['hit9'], cellRender: toFixedCellRender});
        columnSet.push({column: t('hr9'), property: 'hr9', tooltip: tooltipData['hr9'], cellRender: toFixedCellRender}); 
        columnSet.push({column: t('kRate'), property: 'soRate', tooltip: tooltipData['kRate']}); 
        columnSet.push({column: t('bbRate'), property: 'bbRate', tooltip: tooltipData['bbRate']});
    } else if(type === 'hittingType') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('gdDivFly'), property: 'gdDivFly', tooltip: tooltipData['gdDivFly']});
        columnSet.push({column: t('gbRate'), property: 'groundBallRate', tooltip: tooltipData['gdRate']});
        columnSet.push({column: t('lineDriveRate'), property: 'lineDriveRate', tooltip: tooltipData['lineRate']});
        columnSet.push({column: t('whiffRate'), property: 'whiffRate', tooltip: tooltipData['whiff']});
        columnSet.push({column: t('hrDivFly'), property: 'hrDivFly', tooltip: tooltipData['hrPerFly']});
        columnSet.push({column: t('hangRate'), property: 'hangRate', tooltip: tooltipData['hangRate']});
        columnSet.push({column: t('centerRate'), property: 'centerRate', tooltip: tooltipData['centerRate']});
        columnSet.push({column: t('pushRate'), property: 'pushRate', tooltip: tooltipData['pushRate']});
        columnSet.push({column: t('barrelRate'), property: 'barrelRate', tooltip: tooltipData['barrelRate']});
        columnSet.push({column: t('vaildHitRate'), property: 'vaildHitRate', tooltip: tooltipData['vaildHitRate']});
        columnSet.push({column: t('poorlyUnderRate'), property: 'poorlyUnderRate', tooltip: tooltipData['poorlyUnderRate']});
        columnSet.push({column: t('poorlyToppedRate'), property: 'poorlyToppedRate', tooltip: tooltipData['poorlyToppedRate']});
        columnSet.push({column: t('poorlyWeakRate'), property: 'poorlyWeakRate', tooltip: tooltipData['poorlyWeakRate']});
    } else if(type === 'futuresHittingType') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('gdDivFly'), property: 'gdDivFly', tooltip: tooltipData['gdDivFly']});
        columnSet.push({column: t('gbRate'), property: 'groundBallRate', tooltip: tooltipData['gdRate']});
        columnSet.push({column: t('lineDriveRate'), property: 'lineDriveRate', tooltip: tooltipData['lineRate']});
        columnSet.push({column: t('whiffRate'), property: 'swingRate', tooltip: tooltipData['whiff']});
        columnSet.push({column: t('hrDivFly'), property: 'hrDivFly', tooltip: tooltipData['hrPerFly']});
        columnSet.push({column: t('hangRate'), property: 'hangRate', tooltip: tooltipData['hangRate']});
        columnSet.push({column: t('centerRate'), property: 'centerRate', tooltip: tooltipData['centerRate']});
        columnSet.push({column: t('pushRate'), property: 'pushRate', tooltip: tooltipData['pushRate']});
        columnSet.push({column: t('barrelRate'), property: 'barrelRate', tooltip: tooltipData['barrelRate']});
        columnSet.push({column: t('vaildHitRate'), property: 'solidContactRate', tooltip: tooltipData['vaildHitRate']});
        columnSet.push({column: t('poorlyUnderRate'), property: 'poorlyUnderRate', tooltip: tooltipData['poorlyUnderRate']});
        columnSet.push({column: t('poorlyToppedRate'), property: 'poorlyToppedRate', tooltip: tooltipData['poorlyToppedRate']});
        columnSet.push({column: t('poorlyWeakRate'), property: 'lowHitRate', tooltip: tooltipData['poorlyWeakRate']});
    } else if(type.indexOf('futures') > -1 ) {
        columnSet.push({column: t('type'), property: 'type'});
        columnSet.push({column: t('basicStat_pa'), property: 'tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'hit'});
        columnSet.push({column: t('basicStat_b1b'), property: 'b1b'});
        columnSet.push({column: t('basicStat_b2b'), property: 'b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'hr'});
        columnSet.push({column: t('basicStat_bb'), property: 'bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_ibb'), property: 'ibb'});
        columnSet.push({column: t('basicStat_hbp'), property: 'hbp'});
        columnSet.push({column: t('basicStat_k'), property: 'so'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']}); 
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']}); 
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']}); 
        // columnSet.push({column: t('whip'), property: 'whip', tooltip: tooltipData['whip']}); 
    } else {
        columnSet.push({column: t('type'), property: 'type'});
        columnSet.push({column: t('basicStat_pa'), property: 'basicStat_tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'basicStat_ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'basicStat_hit'});
        columnSet.push({column: t('basicStat_b1b'), property: 'basicStat_b1b'});
        columnSet.push({column: t('basicStat_b2b'), property: 'basicStat_b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'basicStat_b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'basicStat_hr'});
        columnSet.push({column: t('basicStat_bb'), property: 'basicStat_bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_ibb'), property: 'basicStat_ibb'});
        columnSet.push({column: t('basicStat_hbp'), property: 'basicStat_hbp'});
        columnSet.push({column: t('basicStat_k'), property: 'basicStat_so'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']}); 
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']}); 
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']}); 
        columnSet.push({column: t('whip'), property: 'whip', tooltip: tooltipData['whip']}); 
    }

    columnSet.forEach((item, idx) => {
        item['key'] = type+(idx+"");
    });

    return columnSet;
}

function parseIntCellRender(key, property, data) {
    let innerData = data[property];
    return <td key={key}>{Number.parseInt(innerData*1)}</td>
}

function toFixedCellRender(key, property, data) {
    let innerData = data[property];
    return <td key={key}>{(innerData*1).toFixed(1)}</td>
}

function percentCellRender(key, property, data) {
    let innerData = data[property];
    let fixedData = (innerData*100).toFixed(1);
    return <td key={key}>{fixedData}</td>
}

function leadingZeroCellRender(key, property, data) {
    let innerData = data[property];
    let fixedData = statString(innerData);

    return <td key={key}>{fixedData}</td>
}

function commonCellRender(key, property, data) {
    let innerData = data[property];

    if(property === 'ballSpeed' || property === 'spinRate') {
        let fixedData = (innerData*1).toFixed(1);
        return <td key={key}>{fixedData}</td>
    } else if(property === 'pitchRate') {
        let fixedData = (innerData*100.).toFixed(1);
        return <td key={key}>{fixedData}</td>
    } else if(property === 'xh') {
        return <td key={key}>{data['b2b']*1+data['b3b']*1+data['hr']*1}</td>
    } else {
        return <td key={key}>{innerData}</td>
    }
}

function statString(stat) {
    let statStringInit = '';

    if(stat*1 === 0) {
        statStringInit = '.000';
    } else if(Number.isInteger(stat)) { // integer
        statStringInit = stat+".000";
    } else if(stat > 0 && stat < 1)  {
        let basicStat = (stat*1).toPrecision(3);
        statStringInit = basicStat.slice(1,5);
    } else if(stat > 1){ 
        let basicStat = (stat*1).toPrecision(4);
        statStringInit = basicStat;
    }

    return statStringInit;
}

function totalBbRender(key, property, data) {
    let ibb = _.isUndefined(data['basicStat_ibb']) ? data['ibb'] : data['basicStat_ibb'];

    let totalBb = (ibb || 0)*1+data[property]*1;

    return <td key={key}>{totalBb}</td>;
}